import { Box, Card, TextField, Typography } from '@mui/material'
import React from 'react'
import { useLocation } from 'react-router-dom';
import Styles from '../Config/Styles'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
const Input = ({ placeholder, startAdornment, type, setValue, value, handlekey, quantity }) => {
    const handleInput = (e) => {
        setValue(e.target.value)
    }
    const location = useLocation()
    return (
        <>
            {quantity ?
                <Box sx={Styles.input.box}>
                    <TextField
                        type={type}
                        value={value}
                        fullWidth
                        placeholder={placeholder}
                        sx={Styles.input.text1}
                        onChange={handleInput}
                        onKeyDown={handlekey}
                    />
                </Box>
                : <Box sx={Styles.input.card}>
                    <TextField
                        type={type}
                        value={value}
                        fullWidth
                        placeholder={placeholder}
                        sx={Styles.input.text}
                        onChange={handleInput}
                        onKeyDown={handlekey}
                        InputProps={{
                            startAdornment:
                                location?.pathname === '/'
                                    ?
                                    <SearchOutlinedIcon sx={Styles.input.search} /> : <Typography
                                        sx={Styles.input.adorn}
                                    >
                                        {startAdornment}
                                    </Typography>
                        }}
                    />
                </Box>
            }
        </>


    )
}

export default Input